import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import DetailView from "@/views/DetailView";
import ActorsView from "@/views/ActorsView";
import ActorDetailView from "@/views/ActorDetailView";
import TVshowsView from "@/views/TVshowsView";
import TvDetailView from "@/views/TvDetailView";
import ComingView from "@/views/ComingView";

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta:{
      title: 'Home'
    }
  },
  {
    path: '/tv-shows',
    name: 'tvShows',
    component: TVshowsView,
    meta:{
      title: 'TV Shows'
    }
  },
  {
    path: '/actors',
    name: 'actors',
    component: ActorsView,
    meta:{
      title: 'Actors'
    }
  },
  {
    path: '/coming-soon',
    name: 'coming',
    component: ComingView,
    meta:{
      title: 'Coming Soon'
    }
  },
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // },
  {
    path: '/detail/:id',
    name: 'detail',
    props: true,
    component: DetailView,
    meta:{
      title: 'Detail'
    }
  },
  {
    path: '/tv/detail/:id',
    name: 'tv.detail',
    props: true,
    component: TvDetailView,
    meta:{
      title: 'Detail'
    }
  },
  {
    path: '/actors/page/:id',
    name: 'actors.page',
    props: true,
    component: ActorsView,
    meta:{
      title: 'Actors'
    }
  },
  {
    path: '/actor/:id',
    name: 'actor',
    props: true,
    component: ActorDetailView,
    meta:{
      title: 'Actor'
    }
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next)=>{
  let title = document.title = `Crystal Movie | ${to.meta.title}`;
  if (to.params.id){
    title += ` - ${to.params.id}`
  }
  document.title = title;
  next();
});

export default router
